/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useFormContext, Controller } from 'react-hook-form';
import { mask } from 'remask';

import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  Button,
  TextField,
  Typography,
  InputAdornment,
  Icon,
  IconButton,
  Grid,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  CircularProgress,
  Backdrop,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import InputMask from 'react-input-mask';

import { instanceAxios } from '../../../InstanceAxios';
import { UFS } from '../../../consts/common';
import { unmaskCpf, unmaskPhonePattern } from '../../../utils/patterns';

import { requestMessageError } from '../helpers';
import { legalization_format_item } from '../helpers/legalization';

import ModalWithTermsOfService from '../components/ModalTermsOfService';
import ModalPrivacyPolicy from '../components/ModalPrivacyPolicy';
import IBGE from '../../../services/IBGE';
import Enotas from '../../../services/Enotas';

import { useStyles } from './styles';

function RegistroBasico(props) {
  const classes = useStyles(props);
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  // const [user, setUserData] = useState({});
  const [loading, setLoading] = useState(false);

  const [validateCity, setValidateCity] = useState(false);

  const [open, setOpen] = useState(false);
  const [hasCompany, setHasCompany] = useState(false);
  const [modal, setModal] = useState('');
  const methods = useFormContext();
  const { control, formState, getValues, resetField, trigger, setError } =
    methods;
  const { errors, isValid } = formState;

  const [cidadesPorUF, setCidadesPorUF] = useState([]);

  const { company, cnpj } = useParams();

  const [message, setMessage] = useState({
    text: '',
    icon: '',
    color: '',
  });

  const sexo = [
    { label: 'Masculino', value: 'Masculino' },
    { label: 'Feminino', value: 'Feminino' },
    { label: 'Prefiro não informar', value: 'Prefiro não informar' },
  ];

  useEffect(() => {
    const hasCnpj = cnpj !== undefined ? true : false;
    setHasCompany(hasCnpj);
    localStorage.setItem('hasCompany', hasCnpj);
  }, [cnpj, hasCompany]);

  const validateCityIsApprovedENotas = async (cid) => {
    if (cid != null) {
      const ibge = cid.municipio ? cid.municipio.id : cid.ibge;
      // todo colocar rota como publica no back
      await Enotas.validateCityIsApprovedENotas('', ibge)
        .then((validate) => {
          if (validate) {
            setValidateCity(false);
            setMessage({
              text: 'A cidade de sua empresa não é contemplada para emissão de notas pelo app. Por este motivo não será possível a realização da assinatura.',
              icon: 'remove_circle_outline',
              color: 'red',
            });
          } else {
            setValidateCity(true);
            setMessage('');
          }
        })
        .catch((err) => {
          setValidateCity(false);
          setMessage({
            text: `ERROR: ${requestMessageError(err)}`,
            icon: 'remove_circle_outline',
            color: 'red',
          });
        });
    }
  };

  const setUF = async (uf) => {
    setLoading(true);

    await IBGE.buscarCidades(uf).then((c) => {
      setCidadesPorUF(c);
    });

    setLoading(false);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const typeCompany = company === 'mei' ? '1' : '2';
      localStorage.setItem('typeCompany', typeCompany);

      const instance = instanceAxios('');

      const data = getValues();

      // obtendo valores raw
      const cpfRawValue = mask(data.cpf, unmaskCpf);
      const telefoneRawValue = mask(data.telefoneUsuario, unmaskPhonePattern);

      const userData = {
        nome: data.nomeCompleto,
        email: data.emailUsuario,
        password: data.senha,
        cpf: cpfRawValue,
        data_nascimento: data.dataNascimento,
        sexo: data.sexo.includes('Prefiro') ? 'NaoInformado' : data.sexo,
        telefone: telefoneRawValue,
      };

      const response = await instance.post('/users/exists/', {
        email: data.emailUsuario,
        cpf: cpfRawValue,
      });

      if (response.data?.exists) {
        if (response.data.fields.cpf) {
          setError('cpf', {
            type: 'custom',
            message: 'Já existe um usuário cadastrado com este cpf.',
          });
        }

        if (response.data.fields.email) {
          setError('emailUsuario', {
            type: 'custom',
            message: 'Já existe um usuário cadastrado com este email.',
          });
        }

        setMessage({
          text: 'ERROR: Não foi possível continuar o cadastro.',
          icon: 'remove_circle_outline',
          color: 'red',
        });
      } else {
        const user = userData;
        handleCompanyType(typeCompany, user);
      }
    } catch (error) {
      setMessage({
        text: `ERROR: ${requestMessageError(error)}`,
        icon: 'remove_circle_outline',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCompanyType = async (type, user) => {
    setLoading(true);

    const uuid =
      type === '1'
        ? 'd490cb59-db44-4a6b-87b9-07a285d79236'
        : '0f36236d-e234-4656-a6e8-6ea2ac5dcf8d';

    const instance = instanceAxios();

    if (hasCompany) {
      history.push({
        pathname: '/signature',
        state: {
          openingMEICompany: type === '1',
          user,
          portal: false,
        },
      });
    } else {
      await instance
        .get(`/listarServicos/${uuid}`)
        .then(async (res) => {
          if (res.data?.length > 0) {
            const itemFilter = res.data[0];

            legalization_format_item(itemFilter);
            setLoading(false);

            const result = await instance.get(`/buscarPlanoAssinatura/${type}`);

            history.push({
              pathname: '/open',
              state: {
                item: itemFilter,
                signaturePlan: result.data[0],
                portal: false,
                user: {
                  ...user,
                  idPlano: type,
                },
              },
            });
          } else {
            throw new Error('Lista de serviços vazia');
          }
        })
        .catch((err) => {
          setLoading(false);
          handleClose();
          setMessage({
            text: `ERROR: ${requestMessageError(err)}`,
            icon: 'remove_circle_outline',
            color: 'red',
          });
        });
    }
  };

  function handleHasCompany(company) {
    setHasCompany(company);
  }

  function handleOpen(item, currentHasCompany) {
    setModal(item);

    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <div>
        <Dialog
          scroll="paper"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <DialogContent dividers>
            {modal === 'termos' && <ModalWithTermsOfService />}
            {modal === 'politica' && <ModalPrivacyPolicy />}
          </DialogContent>
          <DialogActions>
            {(modal === 'termos' ||
              modal === 'politica' ||
              modal === 'porque') && (
                <Button className={classes.confirm} onClick={handleClose}>
                  Ok
                </Button>
              )}
          </DialogActions>
        </Dialog>
      </div>
      <>
        <Controller
          control={control}
          name="nomeCompleto"
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              error={!!errors?.nomeCompleto}
              helperText={
                errors?.nomeCompleto ? errors.nomeCompleto.message : ''
              }
              label="Nome completo"
              autoFocus
              id="nomeCompleto"
              variant="outlined"
              fullWidth
              required
            />
          )}
        />
        <Controller
          control={control}
          name="cpf"
          defaultValue=""
          render={({ field: { onChange, onBlur, ref, value } }) => (
            <InputMask
              mask="999.999.999-99"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
            >
              {(inputProps = ref) => (
                <TextField
                  name="cpf"
                  error={!!errors?.cpf}
                  helperText={errors?.cpf ? errors.cpf.message : ''}
                  required
                  label="CPF"
                  id="cpf"
                  variant="outlined"
                  fullWidth
                  {...inputProps}
                />
              )}
            </InputMask>
          )}
        />

        <Controller
          control={control}
          name="emailUsuario"
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              error={!!errors?.emailUsuario}
              helperText={
                errors?.emailUsuario ? errors.emailUsuario.message : ''
              }
              style={{ width: '100%' }}
              label="E-mail"
              id="emailUsuario"
              variant="outlined"
              fullWidth
              required
            />
          )}
        />
        <Controller
          control={control}
          name="dataNascimento"
          defaultValue=""
          render={({ field: { onChange, onBlur, ref, value } }) => (
            <InputMask
              mask="99/99/9999"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
            >
              {(inputProps = ref) => (
                <TextField
                  name="dataNascimento"
                  error={!!errors?.dataNascimento}
                  helperText={
                    errors?.dataNascimento ? errors.dataNascimento.message : ''
                  }
                  label="Data nascimento"
                  id="dataNascimento"
                  variant="outlined"
                  fullWidth
                  required
                  {...inputProps}
                />
              )}
            </InputMask>
          )}
        />
        <Controller
          control={control}
          name="senha"
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              error={!!errors?.senha}
              helperText={errors?.senha ? errors.senha.message : ''}
              style={{ width: '100%' }}
              label="Senha"
              id="senha"
              variant="outlined"
              fullWidth
              required
              InputProps={{
                className: 'pr-2',
                type: showPassword ? 'text' : 'password',
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      <Icon className="text-20" color="action">
                        {showPassword ? 'visibility' : 'visibility_off'}
                      </Icon>
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />

        <Controller
          control={control}
          name="confirmarSenha"
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              error={!!errors?.confirmarSenha}
              helperText={
                errors?.confirmarSenha ? errors.confirmarSenha.message : ''
              }
              style={{ width: '100%' }}
              label="Confirmar senha"
              id="confirmarSenha"
              variant="outlined"
              fullWidth
              required
              InputProps={{
                className: 'pr-2',
                type: showPassword ? 'text' : 'password',
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      <Icon className="text-20" color="action">
                        {showPassword ? 'visibility' : 'visibility_off'}
                      </Icon>
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
        <Controller
          control={control}
          name="telefoneUsuario"
          defaultValue=""
          render={({ field: { onChange, onBlur, ref, value } }) => (
            <InputMask
              mask="(99) 99999-9999"
              value={value}
              onChange={onChange}
              onBlur={onBlur}
            >
              {(inputProps = ref) => (
                <TextField
                  name="telefoneUsuario"
                  error={!!errors?.telefoneUsuario}
                  helperText={
                    errors?.telefoneUsuario
                      ? errors.telefoneUsuario.message
                      : ''
                  }
                  required
                  label="Celular"
                  id="telefoneUsuario"
                  variant="outlined"
                  fullWidth
                  {...inputProps}
                />
              )}
            </InputMask>
          )}
        />
        <Grid container>
          <Grid item xs={12} lg={12}>
            <div className={classes.formGroup} style={{ width: '100%' }}>
              <Typography
                className={classes.formGroupTitle}
                color="textSecondary"
              >
                Sexo
              </Typography>
              <Controller
                name="sexo"
                control={control}
                render={({ field }) => (
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <RadioGroup
                      {...field}
                      aria-label="sexo"
                      className={classes.group}
                      row={sexo.length < 4}
                    >
                      {sexo.map((opt) => (
                        <FormControlLabel
                          key={opt.value}
                          value={opt.value}
                          control={<Radio />}
                          label={opt.label}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                )}
              />
            </div>
          </Grid>
        </Grid>
        {errors.sexo && (
          <Typography style={{ width: '100%', color: 'red' }}>
            {errors.sexo.message}
          </Typography>
        )}

        <Grid container>
          <Grid item xs={12} lg={12}>
            <div className={classes.formGroup}>
              <Typography
                className={classes.formGroupTitle}
                color="textSecondary"
              >
                Localização da empresa
              </Typography>

              <FormControl
                component="fieldset"
                className={classes.formControl}
                style={{ width: '100%' }}
              >
                <div className={classes.group} style={{ flexWrap: 'wrap' }}>
                  <Controller
                    name="estado"
                    control={control}
                    defaultValue=""
                    render={({ field: { ref, ...field } }) => (
                      <Autocomplete
                        {...field}
                        options={UFS}
                        onChange={(_, data) => {
                          setUF(data);
                          field.onChange(data);

                          resetField('municipio');
                        }}
                        getOptionLabel={(option) => option}
                        style={{ marginRight: 10 }}
                        renderOption={(option) => <span>{option}</span>}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            id="estado"
                            name="estado"
                            label="UF"
                            error={!!errors?.estado}
                            helperText={errors?.estado ? 'Selecione UF' : ''}
                            InputLabelProps={{
                              style: { fontSize: 16 },
                              shrink: true,
                            }}
                            variant="outlined"
                            inputRef={ref}
                            required
                            type="search"
                          />
                        )}
                      />
                    )}
                  />
                  <Controller
                    name="municipio"
                    control={control}
                    defaultValue={{ id: '', nome: '' }}
                    render={({ field: { ref, ...field } }) => (
                      <Autocomplete
                        {...field}
                        style={{ flexGrow: 1, minWidth: 200 }}
                        options={cidadesPorUF}
                        getOptionLabel={(option) => option.nome}
                        onChange={(_, data) => {
                          validateCityIsApprovedENotas(data);
                          field.onChange(data);
                        }}
                        renderOption={(option) => <span>{option.nome}</span>}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="municipio"
                            id="municipio"
                            label="Selecione uma cidade"
                            error={!!errors?.municipio}
                            helperText={
                              errors?.municipio
                                ? 'Município deve ser selecionado'
                                : ''
                            }
                            style={{ width: '100%' }}
                            InputLabelProps={{
                              style: { fontSize: 16 },
                              shrink: true,
                            }}
                            variant="outlined"
                            inputRef={ref}
                            required
                            type="search"
                          />
                        )}
                      />
                    )}
                  />
                </div>
                <Typography
                  style={{ display: 'inline-block', cursor: 'pointer' }}
                  className={classes.checkBoxTextContent}
                  onClick={() => handleOpen('porque')}
                >
                  Por que esses campos são obrigatórios? E se eu ainda não tenho
                  empresa?
                </Typography>
                {!validateCity && message.text !== '' && (
                  <Typography style={{ color: 'red' }}>
                    {message.text}{' '}
                    <Icon className="text-20">{message.icon}</Icon>
                  </Typography>
                )}
              </FormControl>
            </div>
          </Grid>
        </Grid>

        <Controller
          name="termsOfService"
          control={control}
          render={({ field }) => (
            <Checkbox
              {...field}
              onChange={(e) => {
                field.onChange(e.target.checked);

                trigger('termsOfService');
              }}
              checked={field.value}
            />
          )}
        />

        <Typography
          style={{ display: 'inline-block' }}
          className={classes.checkBoxText}
        >
          Eu li e concordo com estes{' '}
          <Typography
            component="span"
            style={{ display: 'inline-block', cursor: 'pointer' }}
            className={classes.checkBoxTextContent}
            onClick={() => handleOpen('termos')}
          >
            termos de uso
          </Typography>
          {' e '}
          <Typography
            component="span"
            style={{ display: 'inline-block', cursor: 'pointer' }}
            className={classes.checkBoxTextContent}
            onClick={() => handleOpen('politica')}
          >
            politica de privacidade.
          </Typography>
        </Typography>
        <Button
          type="button"
          variant="contained"
          fullWidth
          disabled={!isValid || !validateCity || loading}
          className={classes.confirm}
          onClick={handleSubmit}
        >
          {loading ? (
            <CircularProgress color="primary" size={25} />
          ) : (
            'CRIAR CONTA'
          )}
        </Button>

        {validateCity && message.text !== '' && (
          <Typography style={{ color: 'red' }}>
            {message.text} <Icon className="text-20">{message.icon}</Icon>
          </Typography>
        )}
      </>
    </div>
  );
}

export default RegistroBasico;
